import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {PageQueryInterface} from "../../../_models/page.interface";

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    private readonly DASHBOARD_API: string;

    constructor(private http: HttpClient) {
        this.DASHBOARD_API = `${environment.apiUrl}/dashboard/`;
    }

    async getSubscription(): Promise<any> {
        return await this.http.post(this.DASHBOARD_API + 'get-subscription', {}).toPromise();
    }

    async getCountCertificates(): Promise<any> {
        return await this.http.post(this.DASHBOARD_API + 'get-certificates', {}).toPromise();
    }

    async getReminders(): Promise<any> {
        return await this.http.post(this.DASHBOARD_API + 'get-reminders', {}).toPromise();
    }

    async getScorecardLatest(): Promise<any> {
        return await this.http.post(this.DASHBOARD_API + 'get-scorecard-latest', {}).toPromise();
    }

    async getUpcomingCEUs(pageQuery: PageQueryInterface): Promise<any> {
        return await this.http.post(this.DASHBOARD_API + 'get-upcoming-ceus', pageQuery).toPromise();
    }

    async getNotifications(): Promise<any> {
        return await this.http.post(this.DASHBOARD_API + 'get-notifications', {}).toPromise();
    }
}